import React from 'react'
import { Question, QuestionProps } from '@zuto/molecules'
import { fireReactGAEvent } from '../Questions/utils'

interface AppFormQuestionProps extends QuestionProps {
  questionKey: string
  showHintByDefault?: boolean
}

const AppFormQuestion = ({ questionKey, ...props }: AppFormQuestionProps) => {
  const hintClicked = () => {
    fireReactGAEvent({
      category: 'Application Form',
      action: 'Show Hint',
      label: questionKey
    })
  }

  return (
    <Question
      {...props}
      hintOnClick={hintClicked}
      showHintByDefault={props.showHintByDefault}
    />
  )
}

export default AppFormQuestion
